<template>
    <card>
        <card-header>
            <card-overline>K-Warenausgang</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Ausgangsdatum</th>
                    <th>Stückzahl</th>
                    <th>Lieferschein</th>
                    <th>Versandetikett</th>
                    <th>Operator</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="outgoing in outgoingGoodsClient" :key="outgoing.index">
                    <td>{{ outgoing.delivery_at_string }}</td>
                    <td>{{ outgoing.amount_string }}</td>
                    <td>
                        <a :href="this.$$route('delivery-bill.download', {'delivery': outgoing.id})" target="_blank">
                            <translate>Lieferschein</translate>
                        </a>
                    </td>
                    <td v-if="outgoing.ups_label"><a :href="this.$$route('ups-label.download', {'delivery': outgoing.id})" target="_blank">UPS Label</a></td>
                    <td v-if="!outgoing.ups_label">-</td>
                    <td>{{ outgoing?.admin_user?.name }}</td>
                    <td>
                        <form-button type="button" dense="true"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.delivery.outgoing-goods-client.delete', {'askForQuote': this.askForQuote, 'delivery': outgoing.id})"
                                     icon="trash-delete-bin-2"/>
                    </td>
                </tr>
                </tbody>
            </table>
            <modal-dialog title="K-Warenausgang löschen" text="Möchten Sie den K-Warenausgang wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>
        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary"
                         @click="outgoingGoodsClientModal = !outgoingGoodsClientModal" icon="package-box-arrow-up" :disabled="disabledTab || ! hasIncomingGoodsProducer">
                neuer Warenausgang
            </form-button>
            <outgoing-goods-client-modal v-if="outgoingGoodsClientModal"
                                   :askForQuote="askForQuote"
                                   :admin-users="adminUsers"
                                   @closeDialog="outgoingGoodsClientModal = false"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import OutgoingGoodsClientModal from '@partfactory/Pages/Admin/AskForQuote/Modals/OutgoingGoodsClientModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
export default {
    name: 'OutgoingGoodsClient',
    components: {ModalDialog, OutgoingGoodsClientModal, FormButton, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            outgoingGoodsClientModal: false,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        outgoingGoodsClient() {
            let outgoingGoodsClient = [];
            this.askForQuote?.outgoing_goods_client.forEach(outgoing => {
                outgoing.delivery_at_string = this.$moment(outgoing.delivery_at).format('DD.MM.YYYY');
                outgoing.amount_string = outgoing.amount + ' von ' + this.askForQuote.producer_order.amount;

                outgoingGoodsClient.push(outgoing);
            });

            return outgoingGoodsClient;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasIncomingGoodsProducer() {
            return this.askForQuote.incoming_goods_producer.length > 0;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
